import { render, staticRenderFns } from "./dibu.vue?vue&type=template&id=5b1e8128&scoped=true"
import script from "./dibu.vue?vue&type=script&lang=js"
export * from "./dibu.vue?vue&type=script&lang=js"
import style0 from "./dibu.vue?vue&type=style&index=0&id=5b1e8128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1e8128",
  null
  
)

export default component.exports